import {AuswahlBericht} from '../v2024';

export const AuswahlBerichtEnumLabels = {
    _1: '1' as AuswahlBericht,
    _2: '2' as AuswahlBericht
};

